'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();
var MOLECULE_NAME = 'action-dropdown';

var ActionDropdown = function (_Component) {
  _inherits(ActionDropdown, _Component);

  function ActionDropdown(props) {
    _classCallCheck(this, ActionDropdown);

    var _this = _possibleConstructorReturn(this, (ActionDropdown.__proto__ || Object.getPrototypeOf(ActionDropdown)).call(this, props));

    _this.updateFeesSelection = _this.updateFeesSelection.bind(_this);
    _this.openSelectedHyperlink = _this.openSelectedHyperlink.bind(_this);

    var content = _this.props.content;
    var type = content.type;


    if (type === 'fees') {
      _this.state = {
        selectedIndex: 0
      };
    }
    return _this;
  }

  _createClass(ActionDropdown, [{
    key: 'updateFeesSelection',
    value: function updateFeesSelection(event) {
      var selectedIndex = event.target.selectedIndex;
      var callback = this.props.callback;


      if (callback) {
        callback(event.target, selectedIndex);
      }

      this.setState({
        selectedIndex: selectedIndex
      });
    }
  }, {
    key: 'openSelectedHyperlink',
    value: function openSelectedHyperlink(event) {
      var selectedIndex = event.target.selectedIndex;

      var selectedOption = event.target.options[selectedIndex];
      var href = selectedOption.getAttribute('data-href');
      var target = selectedOption.getAttribute('data-target');
      var callback = this.props.callback;


      if (callback) {
        callback(event.target, selectedIndex);
      }

      window.open(href, target);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className;
      var id = config.id;
      var type = content.type,
          items = content.items;

      var markup = void 0;

      switch (type) {
        case 'fees':
          {
            var selectedIndex = this.state.selectedIndex;

            markup = _react2.default.createElement(
              'div',
              { className: MOLECULE_NAME + '__container' },
              _react2.default.createElement(
                'select',
                {
                  id: id,
                  onChange: this.updateFeesSelection,
                  className: MOLECULE_NAME + '__list ' + className
                },
                items.map(function (item) {
                  return _react2.default.createElement(
                    'option',
                    { key: item.key, 'data-pa-click': item.key },
                    item.text
                  );
                })
              ),
              _react2.default.createElement(
                'div',
                { className: MOLECULE_NAME + '__para' },
                htmlToReactParser.parse(items[selectedIndex].para)
              ),
              _react2.default.createElement(
                'div',
                { className: MOLECULE_NAME + '__footer' },
                htmlToReactParser.parse(items[selectedIndex].footerCopy)
              )
            );
            break;
          }
        case 'hyperlinks':
          {
            markup = _react2.default.createElement(
              'div',
              { className: MOLECULE_NAME + '__container' },
              _react2.default.createElement(
                'select',
                {
                  id: id,
                  onChange: this.openSelectedHyperlink,
                  className: MOLECULE_NAME + '__list ' + className
                },
                items.map(function (item) {
                  return _react2.default.createElement(
                    'option',
                    { key: item.key, 'data-pa-click': item.key, 'data-href': item.href, 'data-target': item.target || '_self' },
                    item.text
                  );
                })
              )
            );
            break;
          }
        default:
      }

      return markup;
    }
  }]);

  return ActionDropdown;
}(_react.Component);

exports.default = ActionDropdown;


ActionDropdown.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  callback: _propTypes2.default.func,
  className: _propTypes2.default.string,
  content: _propTypes2.default.shape({
    type: _propTypes2.default.oneOf(['hyperlinks', 'fees']).isRequired,
    items: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape({
      key: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      para: _propTypes2.default.string,
      footerCopy: _propTypes2.default.string
    }), _propTypes2.default.shape({
      key: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      href: _propTypes2.default.string.isRequired,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    })])).isRequired
  })
};

ActionDropdown.defaultProps = {
  config: {
    id: ''
  },
  content: {
    type: 'fees',
    items: [{
      text: 'Default text (25 characters max)',
      key: 'no-selection',
      para: '',
      footerCopy: ''
    }, {
      text: '< £xxxx per month',
      key: 'less-than-xxxx',
      para: 'You should pay <h3>X.XX%</h3> + 20p per transaction</p>',
      footerCopy: ''
    }, {
      text: '£xxxx - £yyyy per month',
      key: 'xxxx-yyyy',
      para: 'You should pay <h3>Y.YY%</h3> + 20p per transaction</p>',
      footerCopy: 'maximum 240 characters (max 3 lines)'
    }, {
      text: '> £yyyy per month',
      key: 'greater-than-yyyy',
      para: '',
      footerCopy: 'Call XXXX XXX XXXXX for pricing'
    }]
  },
  callback: function callback() {},
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/action-dropdown/jsx/ActionDropdown.js
// module id = 562
// module chunks = 4